// packages
import { atom } from 'recoil';
// types
import { searchCounterType } from '../types';

export const fetchNextOrganisationJobOpeningsAtom = atom<searchCounterType>({
  key: ' fetchNextOrganisationJobOpeningsAtom',
  default: { count: 4 },
});
